
const calculateDateInterval = (dateInitial, dateFinal) => {
    if(!dateFinal || !dateInitial) return '-';
    var timeInitial = (new Date(dateInitial)).getTime();
    var timeFinal = (new Date(dateFinal)).getTime();
    var interval = Math.abs((timeInitial - timeFinal)/1000);

    var inDays = (interval / 60) / 60 / 24;
    var years = Math.trunc(inDays / 365);
    var months = Math.trunc(inDays % 365 / 30);
    var days = Math.trunc(inDays % 365 % 30);

    var yearText = years ? `${years} ano${years > 1 ? 's' : ''}` : '';
    var monthText = months ? `${months} ${months === 1 ? 'mês' : 'meses'}` : '';
    var dayText = days ? `${days} dia${days > 1 ? 's' : ''}` : '';
    return  `${yearText} ${monthText} ${dayText}`;
}

const downloadCsv = (header, rows, name = 'dados-ctruck') => {
    var data = header.join('; ') + '\n';
    rows.forEach(columns => {
        data += columns.map(column => {
            var replaced = String(column || '').replace(/;/g, '');
            if(!replaced && typeof replaced !== 'number') return '-';
            return replaced;
        }).join(';') + '; \n';
    });
    var iconv = require('iconv-lite');
    var fileDownload = require('js-file-download');
    fileDownload(iconv.encode(data, 'iso88591'), `${name}.csv`);
}

module.exports = {
    calculateDateInterval,
    downloadCsv
}